module.exports = "https://coursera_assets.s3.amazonaws.com/images/108d58c4a66c30ddba437e01687b6c2f.png";